export enum Roles {
	Procurement = 'R001',
	Compliance = 'R002',
	AccountManager = 'R004',
	VendorAuthorizedOfficer = 'R005'
}

export const isProcurement = (role: string | null) =>
	role === Roles.Procurement;
export const isComplience = (role: string | null) => role === Roles.Compliance;
